import React from "react";
import { Editor } from "primereact/editor";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

const RichInput = ({
  value,
  onChange,
  placeholder = "Type here…",
  disable = false,
  error = false,
  helperText,
}) => {
  // Toolbar template: only bold, italic, underline, bullet, numbered list
  const headerTemplate = (
    <span className="ql-formats">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-list" value="bullet" />
      <button className="ql-list" value="ordered" />
    </span>
  );

  return (
    <>
      <div
        className={`flex flex-col justify-start items-start w-full gap-2.5 rounded-lg border text-sm
        ${disable ? "text-[#999] border-[#999]/30" : ""}
        ${error ? "border-red-500" : "border-[#a48572]/50"}`}
      >
        <div className="w-full p-2">
          <Editor
            value={value}
            onTextChange={(e) => onChange(e.htmlValue)}
            headerTemplate={headerTemplate}
            style={{
              minHeight: "120px",
              height: "200px",
              overflowY: "auto",
              backgroundColor: disable ? "#f5f5f5" : "white",
              pointerEvents: disable ? "none" : "auto",
              textAlign: "justify",
            }}
            placeholder={placeholder}
          />
        </div>
      </div>
      {error && helperText && (
        <p className="text-xs text-red-600 mt-2">{helperText}</p>
      )}
    </>
  );
};

export default RichInput;
